import { AddCircle, Clear, Delete, Edit, Search } from "@mui/icons-material";
import { Box, Card, CardContent, Grid } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortModel, GridSortDirection } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import ConfirmationDialog from "../../../components/confirmationDialog";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DialogCreate from "./modal/dialogCreate";
import DialogEdit from "./modal/dialogEdit";
import TextInput from "../../../components/hookForms/textField";
import Tooltip from "@mui/material/Tooltip";
import messages from "../../../utils/messages";
import serviceMotivoMovimentcaoInstalacao from "../../../services/serviceMotivoMovimentacaoInstalacao";
import { toast } from "react-toastify";
/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";

const MotivoMovimentacao = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Rebalance - Motivos de movimentação");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [openNew, setOpenNew] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
          field: "",
          sort: "" as GridSortDirection
        }
      ]);

    const [exclusionState, setExclusionState] = useState({
        data: {
            id: "",
            valorInjecaoFixa: "",
            valorInjecaoPercentual: "",
            descricao: "",
            tipo: "",
            tipoAlteracao: "",
            observacao: "",
        },
        open: false,
    });
    const [editState, setEditState] = useState({
        open: false,
        id: "",
        valorInjecaoFixa: "",
        valorInjecaoPercentual: "",
        descricao: "",
        tipo: "",
        tipoAlteracao: "",
        observacao: "",
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            descricao: "",
            tipo: "",
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 130,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                valorInjecaoFixa: params.row.valorInjecaoFixa,
                                valorInjecaoPercentual: params.row.valorInjecaoPercentual,
                                descricao: params.row.descricao,
                                tipo: params.row.tipo,
                                tipoAlteracao: params.row.tipoAlteracao,
                                observacao: params.row.observacao,
                            })
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Excluir">
                                <Delete />
                            </Tooltip>
                        }
                        label="Excluir"
                        disabled={params.row.ativo === "Não"}
                        onClick={() =>
                            setExclusionState({
                                data: {
                                    id: params.id.toString(),
                                    valorInjecaoFixa: params.row.valorInjecaoFixa,
                                    valorInjecaoPercentual: params.row.valorInjecaoPercentual,
                                    descricao: params.row.descricao,
                                    tipo: params.row.tipo,
                                    tipoAlteracao: params.row.tipoAlteracao,
                                    observacao: params.row.observacao,
                                },
                                open: true,
                            })
                        }
                        // disabled={params.row.ativo === "Não"}
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "rebalanceMotivoMovimentacaoInstalacaoID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Descrição motivo",
                field: "descricao",
                type: "string",
                width: 300,
            },
            {
                headerName: "Tipo",
                field: "tipo",
                type: "string",
                width: 100,
            },
            {
                headerName: "Injeção/Cota",
                field: "tipoAlteracao",
                type: "string",
                width: 130,
            },
            {
                headerName: "Valor injeção fixa",
                field: "valorInjecaoFixa",
                type: "number",
                headerAlign: "left",
                width: 130,
            },
            {
                headerName: "Valor injeção percentual",
                field: "valorInjecaoPercentual",
                type: "number",
                headerAlign: "left",
                width: 200,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    const tipoOptions = [
        { label: "Inclusão", value: "I" },
        { label: "Alteração", value: "A" },
        { label: "Exclusão", value: "E" },
    ];

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceMotivoMovimentcaoInstalacao
            .getWithFilter({ ...filters, take: pageSize, currentPage: page + 1, 
                sortExpression: sortModel[0]?.field ?? "", sortDirection: sortModel[0]?.sort ?? ""})
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const handleClickOpenNew = () => {
        setOpenNew(true);
    };

    const handleDelete = async () => {
        const treatedValues = {
            ...exclusionState.data,
            rebalanceMotivoMovimentacaoInstalacaoID: exclusionState.data.id,
            ativo: "N",
            tipoAlteracao: exclusionState.data.tipoAlteracao === "Injeção" ? "I" : "C",
            tipo: exclusionState.data.tipo === "Inclusão" ? "I" : exclusionState.data.tipo === "Alteração" ? "A" : "E",
        };

        serviceMotivoMovimentcaoInstalacao
            .update(treatedValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.deleteSucess);
                }
            })
            .catch((err) => {
                toast.error(messages.deleteError, err);
            })
            .finally(() => {
                setExclusionState({
                    data: {
                        id: "",
                        valorInjecaoFixa: "",
                        valorInjecaoPercentual: "",
                        descricao: "",
                        tipo: "",
                        tipoAlteracao: "",
                        observacao: "",
                    },
                    open: false,
                });
                getAllWithFilters(filters);
            });
    };

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            tipoFaturaCliente: values.tipoFaturaCliente === "Todos" ? "" : values.tipoFaturaCliente,
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    const onClear = () => {
        reset();
        setFilters(null);
        getAllWithFilters(null);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <TextInput
                                                name="descricao"
                                                label="Motivo"
                                                control={control}
                                                error={errors}
                                                maxLength={20}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <AutoComplete
                                                name="tipo"
                                                label="Tipo"
                                                options={tipoOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="outlined"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <Button
                                                style={{ marginTop: 16, marginBottom: 8 }}
                                                variant="contained"
                                                color="primary"
                                                startIcon={<AddCircle />}
                                                onClick={handleClickOpenNew}
                                                disableElevation
                                                fullWidth
                                                size="medium"
                                            >
                                                Novo
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.rebalanceMotivoMovimentacaoInstalacaoID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <ConfirmationDialog
                        open={exclusionState?.open}
                        title={"Excluir"}
                        message={messages.deleteConfirmation}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() =>
                            setExclusionState({
                                data: {
                                    id: "",
                                    valorInjecaoFixa: "",
                                    valorInjecaoPercentual: "",
                                    descricao: "",
                                    tipo: "",
                                    tipoAlteracao: "",
                                    observacao: "",
                                },
                                open: false,
                            })
                        }
                        onCancel={() =>
                            setExclusionState({
                                data: {
                                    id: "",
                                    valorInjecaoFixa: "",
                                    valorInjecaoPercentual: "",
                                    descricao: "",
                                    tipo: "",
                                    tipoAlteracao: "",
                                    observacao: "",
                                },
                                open: false,
                            })
                        }
                        onConfirm={() => {
                            setExclusionState({
                                data: {
                                    id: "",
                                    valorInjecaoFixa: "",
                                    valorInjecaoPercentual: "",
                                    descricao: "",
                                    tipo: "",
                                    tipoAlteracao: "",
                                    observacao: "",
                                },
                                open: false,
                            });
                            handleDelete();
                        }}
                    />

                    <DialogCreate
                        open={openNew}
                        onSuccess={() => onSuccessAction()}
                        onClose={() => {
                            setOpenNew(false);
                        }}
                    />

                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            valorInjecaoPercentual: editState.valorInjecaoPercentual,
                            valorInjecaoFixa: editState.valorInjecaoFixa,
                            descricao: editState.descricao,
                            tipo: editState.tipo,
                            tipoAlteracao: editState.tipoAlteracao,
                            observacao: editState.observacao,
                        }}
                        onClose={() => {
                            setEditState({
                                open: false,
                                id: "",
                                valorInjecaoFixa: "",
                                valorInjecaoPercentual: "",
                                descricao: "",
                                tipo: "",
                                tipoAlteracao: "",
                                observacao: "",
                            });
                        }}
                    />
                </CardContent>
            </Card>
        </Container>
    );
};

export default MotivoMovimentacao;
